import { useEffect, useState } from 'react'
import { getFirebase } from './firebase/client'

export const FEATURE_DEFAULTS = {
  orderConfirmation: true,
  myOrders: true,
  savedAddresses: true,
  lifetimeTotal: true,
  beamPayment: true,
  bankTransfer: true,
  slipUpload: true,
  productImages: true,
  worshipImages: true,
  tracking: true,
  contact: true,
  /** ลูกค้าค้นหารายชื่อลูกค้า (Autocomplete) — ปิดเป็นค่าเริ่มต้น · rules customers อ่านค่าเดียวกัน · LINE แอดมินค้นได้เสมอ */
  customerAutocomplete: false,
  /** ลูกค้าค้นชื่อ+วันเกิดผู้ร่วมพิธี — ปิดเป็นค่าเริ่มต้น · rules participants อ่านค่าเดียวกัน */
  participantAutocomplete: false,
} as const

export type OrderCusFeatures = Record<keyof typeof FEATURE_DEFAULTS, boolean>

export function parseFeatures(raw: unknown): OrderCusFeatures {
  const source = raw && typeof raw === 'object' ? raw as Record<string, unknown> : {}
  const features = { ...FEATURE_DEFAULTS } as OrderCusFeatures
  for (const key of Object.keys(features) as Array<keyof OrderCusFeatures>) {
    if (typeof source[key] === 'boolean') features[key] = source[key]
  }
  return features
}

export function useOrderCusFeatures(options: { remote?: boolean } = {}): { features: OrderCusFeatures; ready: boolean } {
  const remote = options.remote ?? true
  const [features, setFeatures] = useState<OrderCusFeatures>({ ...FEATURE_DEFAULTS })
  const [ready, setReady] = useState(!remote)
  useEffect(() => {
    if (!remote) {
      setReady(true)
      return
    }
    let active = true
    getFirebase()
      .then((firebase) => firebase.getFeatures())
      .then((raw) => { if (active) setFeatures(parseFeatures(raw)) })
      .catch(() => { /* คงพฤติกรรมเดิมเมื่อ config อ่านไม่ได้ */ })
      .finally(() => { if (active) setReady(true) })
    return () => { active = false }
  }, [remote])
  return { features, ready }
}
